import React from 'react';
import { Building2, Award, Lightbulb } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="about-section">
      <div className="section-container">
        <h2 className="section-title">Über Doctimize</h2>
        
        <div className="about-content">
          {/* Centered Portrait and Info */}
          <div className="about-hero">
            <div className="about-portrait-wrapper">
              <img 
                src="/images/luca-groeflin.jpg" 
                alt="Luca Gröflin - Geschäftsführer von Doctimize"
                className="about-portrait-large"
              />
              <div className="portrait-info">
                <p className="portrait-role">Geschäftsführer</p>
                <p className="portrait-name-large">Luca Gröflin</p>
              </div>
            </div>
          </div>

          {/* Company Description - Centered */}
          <div className="about-description-centered">
            <p className="about-intro-large">
              <strong>Doctimize</strong> steht für strukturierte, intelligente Dokumenten-Automatisierung.
            </p>
            
            <p className="about-text-centered">
              Unser Fokus liegt auf <strong>Effizienz, Qualität und nachhaltiger Prozessoptimierung</strong>.
              Wir kombinieren technisches Know-how mit unternehmerischem Denken – für Lösungen, 
              die <strong>messbaren Mehrwert</strong> schaffen.
            </p>
          </div>

          {/* Personal Story - Full Width Card */}
          <div className="founder-story-card">
            <div className="founder-story-content">
              <p className="founder-text">
                Seit meiner Kindheit faszinieren mich Technik und Computer.
                Mich hat immer interessiert, wie Systeme funktionieren – und wie man sie effizienter machen kann.
              </p>
              
              <p className="founder-text">
                Heute liegt mein Fokus darauf, Unternehmen von repetitiven, administrativen Aufgaben zu entlasten.
                Damit sie sich wieder auf das konzentrieren können, was wirklich Wachstum bringt: <strong>Strategie, Innovation und Kreativität</strong>.
              </p>
              
              <p className="founder-text">
                Ich beschäftige mich intensiv mit modernen Themen wie programmieren, künstlicher Intelligenz und Blockchain – nicht als Trend, 
                sondern als Werkzeuge zur nachhaltigen Prozessoptimierung.
              </p>
              
              <p className="founder-text founder-conclusion">
                Doctimize verbindet <strong>technologische Präzision mit unternehmerischem Verständnis</strong> – für Automatisierung, die wirklich Wirkung zeigt.
              </p>
            </div>
          </div>

          {/* Values - 3 Equal Cards */}
          <div className="about-highlights">
            <div className="highlight-card">
              <div className="highlight-icon">
                <Building2 size={28} />
              </div>
              <h3 className="highlight-title">Schweizer Qualität</h3>
              <p className="highlight-description">
                Entwickelt und gehostet in der Schweiz mit höchsten Qualitätsstandards
              </p>
            </div>

            <div className="highlight-card">
              <div className="highlight-icon">
                <Award size={28} />
              </div>
              <h3 className="highlight-title">Bewährte Expertise</h3>
              <p className="highlight-description">
                Spezialisiert auf Dokumenten-Automation für Finanzdienstleister
              </p>
            </div>

            <div className="highlight-card">
              <div className="highlight-icon">
                <Lightbulb size={28} />
              </div>
              <h3 className="highlight-title">Innovation</h3>
              <p className="highlight-description">
                Kontinuierliche Weiterentwicklung durch KI und moderne Technologien
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
